import { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { Collapse } from "@portex-pro/ui-components";
import Text from "components/Text";

interface StepCollapseProps {
  name: string;
  number: string | number;
  collapseIn: boolean;
  visible: boolean;
  tag?: React.ReactNode;
  footer?: React.ReactNode;
  divProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  headerDivProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

const StepCollapse: FC<StepCollapseProps> = ({
  name,
  number,
  collapseIn,
  visible,
  tag,
  footer,
  divProps,
  headerDivProps,
  children,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="bg-white rounded-[8px] w-full shadow-[0_1px_3px_rgba(0,0,0,0.1)]" {...divProps}>
        <div className="flex flex-col justify-between items-center w-full">
          <div className="px-6 py-4 flex justify-between items-center w-full hover:bg-gray-100" {...headerDivProps}>
            <Text size="large" weight="bold">
              {number ? `${number}. ` : ""}
              {name}
            </Text>
            {tag && <div>{tag}</div>}
          </div>
          <Collapse in={collapseIn} style={{ width: "100%" }}>
            <div className="flex w-full px-6 pb-4">{children}</div>
          </Collapse>
          {footer && <div className="flex w-full pb-4">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default StepCollapse;
